import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as content from '../../../../content'

/**
 * Displays app general information and permitted app edit action.
 */
@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.value.Component,
    content.admin.modals.app.Component,
  ],
  selector: 'atn-admin-app-page-general-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.apps.Collection} */
  public readonly appsEc = ngCore.inject(state.admin.apps.Collection)

  /** @see {@link state.admin.contexts.Feature} */
  private readonly _contextsFeature = ngCore.inject(
    state.admin.contexts.Feature,
  )

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** Currently selected app */
  private readonly _appSg =
    this.appsEc.plugins.currentEntityPlugin.feature.selectors.getEntity()
      .asSignal

  /** Currently selected app name */
  public readonly appNameSg = ngCore.computed(
    (app = this._appSg()) => app?.name,
  )

  /** Currently selected app icon */
  public readonly appIconSg = ngCore.computed(
    (app = this._appSg()) => app?.icon,
  )

  /** Currently selected app description */
  public readonly appDescriptionSg = ngCore.computed(
    (app = this._appSg()) => app?.description,
  )

  /** Currently selected app alias */
  public readonly appAliasSg = ngCore.computed(
    (app = this._appSg()) => app?.alias,
  )

  /** Id of app selected for editing */
  private readonly _appIdSg = ngCore.computed((app = this._appSg()) => app?.id)

  /** Whether the current admin user can edit selected app information */
  public readonly canEditAppSg = ngCore.computed((app = this._appSg()) =>
    state.admin.portalAccess.ContentActionAccess.canEditChild({
      context: this._contextsFeature.selectors.zoneContext.asSignal(),
      entity: app,
      user: this._meFeature.selectors.currentUser.asSignal(),
    }),
  )

  /** Edit app general data */
  public editClickHandler(): void {
    this.appsEc.plugins.editingPlugin.feature.actions.edit
      .from('AppBuilder.GeneralTab.Edit.Icon.Clicked')
      .dispatch({
        id: this._appIdSg(),
      })
  }
}
